// eslint-disable-next-line import/prefer-default-export
export enum USERS {
	USERS_LOAD_START = 'USERS_LOAD_START',
	USERS_LOAD_DONE = 'USERS_LOAD_DONE',
	USERS_LOAD_FAIL = 'USERS_LOAD_FAIL'
}
